import React, { useEffect, useState } from 'react'

function DogPicture() {
    const [imageUrl, setImageUrl] = useState('');

    useEffect(() => {
        fetch('https://dog.ceo/api/breeds/image/random')
        .then((res) => res.json())
        .then((data) => {
            setImageUrl(data.message);
        });
    }, []);

  return (
    <div>
      <img src={imageUrl} />
    </div>
  )
}

export default DogPicture
